/**
 * Checkout UI shell feature flag (MINIAPP-064).
 * Canonical name: MINIAPP_CHECKOUT_UI_SHELL_ENABLED
 * Vite exposure: VITE_MINIAPP_CHECKOUT_UI_SHELL_ENABLED
 * Default: false — never enable for production traffic builds.
 */
export function isCheckoutUiShellEnabled(): boolean {
  const raw = import.meta.env.VITE_MINIAPP_CHECKOUT_UI_SHELL_ENABLED;
  if (typeof raw !== "string") return false;
  const normalized = raw.trim().toLowerCase();
  return normalized === "1" || normalized === "true" || normalized === "yes";
}

export const CHECKOUT_UI_SHELL_FLAG_NAME = "MINIAPP_CHECKOUT_UI_SHELL_ENABLED";
